import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface ToggleChipProps {
  pressed: boolean;
  onToggle: () => void;
  icon?: LucideIcon;
  children: ReactNode;
  /** Toegankelijke naam als de zichtbare tekst te kort is (bijv. "3 of meer spelers"). */
  ariaLabel?: string;
  title?: string;
  className?: string;
}

/**
 * Aan/uit-filterknop (aria-pressed). Actief = volle contrastkleur, geen dikke randen (AGENTS.md §5).
 * Monochroom (slate), 44px touch target, label blijft op één regel.
 */
export function ToggleChip({ pressed, onToggle, icon: Icon, children, ariaLabel, title, className = '' }: ToggleChipProps) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      aria-label={ariaLabel}
      title={title}
      onClick={onToggle}
      className={`inline-flex min-h-11 shrink-0 snap-start items-center gap-1.5 whitespace-nowrap rounded-full px-4 text-sm font-semibold transition-all duration-150 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-900 dark:focus-visible:outline-slate-100 ${
        pressed
          ? 'bg-slate-900 text-slate-50 dark:bg-slate-100 dark:text-slate-900'
          : 'bg-slate-900/5 text-slate-700 hover:bg-slate-900/10 dark:bg-white/10 dark:text-slate-200 dark:hover:bg-white/15'
      } ${className}`}
    >
      {Icon ? <Icon size={16} strokeWidth={2.2} aria-hidden="true" className="shrink-0" /> : null}
      {children}
    </button>
  );
}
